/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-06-11 10:33:54
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-10-19 10:26:19
 */

/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'
import {
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  Cascader,
  Comment,
  Empty,
  Descriptions,
  PageHeader,
  Tree,
  TreeSelect,
  message,
  notification,
  Transfer,
  ConfigProvider,
  Result,
  Carousel,
  Timeline
} from 'ant-design-vue'
// import VueCropper from 'vue-cropper'
import Viewer from 'v-viewer'

Vue.use(Layout)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Card)
Vue.use(Form)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Breadcrumb)
Vue.use(Steps)
Vue.use(Spin)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(Popconfirm)
Vue.use(Cascader)
Vue.use(Comment)
Vue.use(Empty)
Vue.use(Descriptions)
Vue.use(PageHeader)
Vue.use(Tree)
Vue.use(TreeSelect)
// Vue.use(VueCropper)
Vue.use(notification)
Vue.use(Transfer)
Vue.use(ConfigProvider)
Vue.use(Result)
Vue.use(Carousel)
Vue.use(Timeline)

//图片预览插件
Vue.use(Viewer)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning


// WEBPACK FOOTER //
// ./src/core/lazy_lib/components_use.js